// extracted by mini-css-extract-plugin
export var addressText = "parking-reservation-info-table-module--addressText--51f09";
export var container = "parking-reservation-info-table-module--container--2e9dc";
export var feesRow = "parking-reservation-info-table-module--feesRow--329d4";
export var feesText = "parking-reservation-info-table-module--feesText--579fe";
export var infoKeySection = "parking-reservation-info-table-module--infoKeySection--b016d";
export var infoRow = "parking-reservation-info-table-module--infoRow--13770";
export var infoValueSection = "parking-reservation-info-table-module--infoValueSection--32456";
export var servicesText = "parking-reservation-info-table-module--servicesText--5e97e";